import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MENU_CATEGORIES, MENU_CATALOG } from "../../data/site";
import { EASE } from "../../lib/motion";

export const MenuGrid = () => {
  const [cat, setCat] = useState("all");
  const items = cat === "all" ? MENU_CATALOG : MENU_CATALOG.filter((i) => i.category === cat);

  return (
    <section data-testid="menu-grid" className="py-4 sm:py-8">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        {/* Filter pills */}
        <div className="mb-10 flex flex-wrap gap-3">
          {MENU_CATEGORIES.map((c) => {
            const active = cat === c.id;
            return (
              <button
                key={c.id}
                data-testid={`menu-filter-${c.id}`}
                onClick={() => setCat(c.id)}
                className={`rounded-full px-5 py-2 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-150 ${
                  active
                    ? "bg-labyellow text-inkred"
                    : "border border-paper/20 text-paper/70 hover:border-labyellow hover:text-labyellow"
                }`}
              >
                {c.label}
              </button>
            );
          })}
        </div>

        {/* Grid */}
        <motion.div layout className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          <AnimatePresence mode="popLayout">
            {items.map((item, i) => (
              <motion.article
                key={item.id}
                layout
                data-testid={`menu-item-${item.id}`}
                initial={{ opacity: 0, y: 24, scale: 0.98 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.45, ease: EASE, delay: (i % 3) * 0.06 }}
                className="group overflow-hidden rounded-[20px] bg-inkred"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.name}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                  />
                  {item.tag && (
                    <span className="absolute left-4 top-4 rounded-full bg-labred px-3 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-paper">
                      {item.tag}
                    </span>
                  )}
                </div>

                <div className="p-6">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display text-lg uppercase leading-tight tracking-tight text-labyellow">
                      {item.name}
                    </h3>
                    <span className="shrink-0 font-mono text-lg text-labyellow">{item.price}</span>
                  </div>
                  <p className="mt-3 font-body text-sm leading-relaxed text-paper/70">{item.desc}</p>
                  <span className="mt-5 block h-px w-0 bg-labred transition-all duration-300 group-hover:w-full" />
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
